import {NeoModal} from "@/components/@modal/neo.modal";
import {formatTimeWithoutSecods} from "@/libs/helper";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip
} from "@nextui-org/react";
import Image from "next/image";
import {useState} from "react";
import {FaExchangeAlt} from "react-icons/fa";
import {MdDelete, MdEdit} from "react-icons/md";

type ModalActionType = "exchangeRoute" | "deleteBP" | "userMappping" | "";
export const BPInfoWindow = function ({
  routeData,
  routeDetails,
  variantId,
  refreshSingleRoute,
  index,
  currentVariant,
  setCurrentVariant,
  variantRoutesData
}: {
  routeData: UserBoarding_RP;
  routeDetails: RouteDetails_RP;
  variantId: string | number | null;
  refreshSingleRoute: (routeId: number, bpId: number) => Promise<void>;
  index: number;
  currentVariant: any;
  setCurrentVariant: any;
  variantRoutesData: any;
}) {
  const [actionType, setActionType] = useState<ModalActionType>("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalBpEdit, setModalBpEdit] = useState(false);
  const [modalBpDelete, setModalBpDelete] = useState(false);
  const handleExchange = () => {
    // Implement exchange functionality here
    //console.log("Exchange clicked");
    setModalBpEdit(true);
  };

  const handleDelete = () => {
    // Implement delete functionality here
    // console.log("Delete clicked");
    //DeletetBpwindow
    setModalBpDelete(true);
  };
  const handleBpEdit = () => {
    // Implement bp edit functionality here
    //console.log("BP Edit clicked");
    setActionType("userMappping");
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setActionType("");
  };
  return (
    <>
      <div className="rounded-xl bg-white p-2 shadow-sm ring-1 ring-black/5 md:p-2">
        {/* Header */}
        <div className="space-y-1">
          <h2 className="text-sm font-semibold">{routeDetails?.name ?? "#"}</h2>
          <p className="text-xs text-gray-500">
            Manage boarding and user assignments
          </p>
        </div>

        {/* Content */}
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Route Details */}
          <section className="rounded-lg border border-gray-200 bg-gray-50">
            <header className="flex items-center justify-between px-4 py-3">
              <div className="flex items-center gap-2">
                {/* <span className="inline-flex h-5 w-5 items-center justify-center rounded-md bg-yellow-100 text-[11px]"> */}
                {/* yellowroute */}
                <Image
                  src={`/icons/routePlan/yellowroute.svg`}
                  alt={""}
                  width={20}
                  height={20}
                  // className="mb-4"
                />
                {/* </span> */}
                <h3 className="text-sm font-semibold">Boarding Details</h3>
              </div>
              {routeData.fencingId === 0 && (
                <div className="flex items-center gap-2">
                  <Tooltip content="Exchange Route" showArrow color="primary">
                    <span
                      onClick={handleExchange}
                      className="inline-flex cursor-pointer items-center justify-center"
                    >
                      <FaExchangeAlt />
                    </span>
                  </Tooltip>
                  <Tooltip
                    content="Delete Boarding Point"
                    showArrow
                    color="primary"
                  >
                    <span
                      onClick={handleDelete}
                      className="inline-flex cursor-pointer items-center justify-center"
                    >
                      <MdDelete />
                    </span>
                  </Tooltip>
                </div>
              )}
            </header>

            <div className="space-y-3 px-4 pb-4">
              <div className="rounded-lg border bg-white px-3 py-2.5">
                <p className="text-[11px] font-medium text-gray-500">Name</p>
                <p className="text-xs font-semibold text-gray-900">
                  {routeData.name ?? "#"}
                </p>
              </div>

              <div className="flex items-center justify-between rounded-lg border bg-white px-3 py-2.5">
                <p className="text-[11px] font-medium text-gray-500">Time</p>
                <p className="flex items-center gap-2 text-xs font-semibold text-gray-900">
                  <span className="inline-flex h-4 w-4 items-center justify-center rounded-full">
                    <Image
                      src={`/icons/routePlan/clock.svg`}
                      alt={""}
                      width={20}
                      height={20}
                      // className="mb-4"
                    />
                  </span>
                  {/* {formatTimeWithoutSecods(routeDetails?.startTime ?? 0)} -{" "}
                  {formatTimeWithoutSecods(routeDetails?.endTime ?? 0)} */}
                  {formatTimeWithoutSecods(routeData?.time ?? 0)}
                </p>
              </div>
            </div>
          </section>

          {/* Student Details */}
          <section className="rounded-lg border border-gray-200 bg-gray-50">
            <header className="flex items-center justify-between px-4 py-3">
              <div className="flex items-center gap-2">
                {/* <span className="inline-flex h-5 w-5 items-center justify-center rounded-md bg-yellow-100 text-[11px]"> */}
                {/* yellowroute */}
                <Image
                  src={`/icons/studentCap.svg`}
                  alt={""}
                  width={20}
                  height={20}
                  // className="mb-4"
                />
                {/* </span> */}
                <h3 className="text-sm font-semibold">User Details</h3>
              </div>
              {routeData.fencingId === 0 && (
                <div className="flex items-center gap-2">
                  <Tooltip
                    content="Map/Unmap User(s)"
                    showArrow
                    color="primary"
                  >
                    <span
                      onClick={handleBpEdit}
                      className="inline-flex cursor-pointer items-center justify-center"
                    >
                      <MdEdit />
                    </span>
                  </Tooltip>
                </div>
              )}
            </header>

            <div className="px-4 pb-4">
              <div className="mb-2 flex items-center justify-between">
                <p className="text-[11px] font-medium text-gray-500">
                  Mapped Users
                </p>
                <span className="rounded-md bg-yellow-400 px-2 py-0.5 text-[10px] font-semibold text-black">
                  {routeData?.users?.length ?? 0}
                </span>
              </div>

              {routeData?.users.length === 0 ? (
                <p className="w-full rounded-md border bg-white p-2 text-xs text-gray-500 shadow-md">
                  No users mapped
                </p>
              ) : (
                <div className="max-h-28 overflow-y-auto pr-1">
                  <StudentList routeData={routeData} />
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
      <>
        <NeoModal
          actionType={actionType}
          onOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          hasActions={false}
          data={
            actionType === "userMappping" && {
              routeData: routeDetails,
              variantId: variantId,
              userData: routeData,
              setCurrentVariant: setCurrentVariant,
              refreshSingleRoute: refreshSingleRoute,
              handleCloseModal: handleCloseModal,
              index: index
            }
          }
        ></NeoModal>
        <NeoModal
          actionType={"exchangeRoute"}
          onOpen={modalBpEdit}
          onClose={() => setModalBpEdit(false)}
          hasActions={false}
          data={{
            variantId: variantId,
            sourceRoute: routeDetails,
            bpData: routeData,
            variantRoute: variantRoutesData,
            currentVariant: currentVariant,
            setCurrentVariant: setCurrentVariant,
            refreshSingleRoute: refreshSingleRoute
          }}
        ></NeoModal>
        {/* modalBpDelete */}
        <NeoModal
          actionType={"deleteRouteBP"}
          onOpen={modalBpDelete}
          onClose={() => setModalBpDelete(false)}
          hasActions={false}
          data={{
            variantId: variantId,
            sourceRoute: routeDetails,
            bpData: routeData,
            variantRoute: variantRoutesData,
            currentVariant: currentVariant,
            setCurrentVariant: setCurrentVariant,
            refreshSingleRoute: refreshSingleRoute
          }}
        ></NeoModal>
      </>
    </>
  );
};

export default function StudentList({
  routeData
}: {
  routeData: {users: UserBoardingUser_RP[]};
}) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {routeData?.users.map(s => (
        <Popover key={s.admissionNo} placement="top" showArrow offset={10}>
          <PopoverTrigger>
            <div className="flex cursor-pointer items-center gap-2 rounded-md border bg-white px-3 py-2 transition hover:bg-gray-50">
              <span className="inline-flex h-4 w-4 items-center justify-center rounded-sm">
                <Image
                  src="/icons/stuUser.svg"
                  alt="user icon"
                  width={10}
                  height={10}
                />
              </span>
              <span className="truncate text-xs font-medium text-gray-700">
                {s.name}
              </span>
            </div>
          </PopoverTrigger>

          <PopoverContent className="p-3 text-sm">
            <div className="flex flex-col gap-1 text-gray-700">
              <div>
                <strong>Name:</strong> {s.name}
              </div>
              <div>
                <strong>Class:</strong> {s.className}
              </div>
              <div>
                <strong>Section:</strong> {s.section}
              </div>
              <div>
                <strong>Admission No:</strong> {s.admissionNo}
              </div>
            </div>
          </PopoverContent>
        </Popover>
      ))}
      {/* {routeData?.users.map((s: UserBoardingUser_RP) => (
                  <div
                    key={s.admissionNo}
                    className="flex items-center gap-2 rounded-md border bg-white px-3 py-2"
                  >
                    <span className="inline-flex h-4 w-4 items-center justify-center rounded-sm">
                      <Image
                        src={`/icons/stuUser.svg`}
                        alt={""}
                        width={10}
                        height={10}
                        // className="mb-4"
                      />
                    </span>

                    <span className="truncate text-xs font-medium text-gray-700">
                      {s.name}
                    </span>
                  </div>
                ))} */}
    </div>
  );
}
